import React from "react";
import { ListUsersSessionVisitor } from "./ListVisitor/ListUsersSessionVisitor";

const VisitorView: React.FC = () => {
  return (
    <>
      <ListUsersSessionVisitor />
    </>
  );
};

export default VisitorView;
